import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

export const ProtectedLogin = ({ children }) => {
  const { user } = useAuth();

  if (user) {
    // user is not authenticated
    return <Navigate to="/dashboard" />;
  }

  return children;
};
